import * as signalR from '@microsoft/signalr';
import store from '../store';

let signalRConnection: signalR.HubConnection;
let initialized = false;

export default {
  init() {
    // Prevent duplicate init — avoids stacking handlers.
    if (initialized && signalRConnection) {
      return;
    }

    signalRConnection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_HUB_ROOT + '/metricshub', {
        accessTokenFactory: () => store.getters.token,
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .build();

    initialized = true;
    signalRConnection.start().catch((e: any) => {
      console.error('[MetricsHub] Initial connection failed:', e);
    });
  },
  getConnection() {
    return signalRConnection;
  },
  disconnect() {
    initialized = false;
    if (signalRConnection) {
      signalRConnection.stop();
    }
  },
};
